export const commonEnGb = {
  brand: {
    logoAlt: 'Safi logo',
    name: 'Safi',
    vatLabel: 'Safi VAT',
  },
  currencySelectField: {
    groups: {
      other: 'Other',
      suggested: 'Suggested',
    },
  },
  domains: {
    evidence: 'Evidence',
    evidenceLower: 'evidence',
    qualityControl: 'Quality control',
    qualityControlLower: 'quality control',
  },
  values: {
    emptyValue: '-',
  },
} as const;
